import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from './assets/video2.mp4'


const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = { id: "first-splash-row" }
const _hoisted_3 = { id: "splash-screen-acknowledgements" }
const _hoisted_4 = { id: "splash-screen-logos" }
const _hoisted_5 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = {
  id: "video-icon-dummy",
  class: "control-icon-wrapper"
}
const _hoisted_8 = { id: "center-buttons" }
const _hoisted_9 = { id: "right-buttons" }
const _hoisted_10 = { class: "left-content" }
const _hoisted_11 = { class: "bottom-content" }
const _hoisted_12 = {
  id: "controls",
  class: "control-icon-wrapper"
}
const _hoisted_13 = { id: "controls-top-row" }
const _hoisted_14 = {
  key: 0,
  class: "controls-content"
}
const _hoisted_15 = { id: "tools" }
const _hoisted_16 = { class: "tool-container" }
const _hoisted_17 = {
  id: "credits",
  class: "ui-text"
}
const _hoisted_18 = { id: "icons-container" }
const _hoisted_19 = { class: "video-wrapper" }
const _hoisted_20 = { class: "text-center red--text" }
const _hoisted_21 = { class: "credits" }
const _hoisted_22 = { style: {"min-height":"120px"} }
const _hoisted_23 = { class: "text-list" }
const _hoisted_24 = {
  id: "user-experience-footer",
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_folder_view = _resolveComponent("folder-view")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_transition_expand = _resolveComponent("transition-expand")!
  const _component_vue_slider = _resolveComponent("vue-slider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_funding_acknowledgment = _resolveComponent("funding-acknowledgment")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_v_app = _resolveComponent("v-app")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorldWideTelescope, {
          "wwt-namespace": _ctx.wwtNamespace,
          class: _normalizeClass({ pointer: _ctx.lastClosePt !== null }),
          onPointermove: _ctx.onPointerMove,
          onPointerup: _ctx.onPointerUp,
          onPointerdown: _ctx.onPointerDown
        }, null, 8, ["wwt-namespace", "class", "onPointermove", "onPointerup", "onPointerdown"]),
        _createVNode(_component_v_overlay, {
          "model-value": _ctx.showSplashScreen,
          absolute: "",
          opacity: "0.6",
          style: _normalizeStyle(_ctx.cssVars),
          id: "splash-overlay"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              id: "splash-screen",
              style: _normalizeStyle(_ctx.cssVars)
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_font_awesome_icon, {
                  id: "close-splash-button",
                  onClick: _ctx.closeSplashScreen,
                  icon: "xmark"
                }, null, 8, ["onClick"]),
                _cache[31] || (_cache[31] = _createElementVNode("div", { id: "splash-screen-text" }, [
                  _createElementVNode("p", null, "Want to see how"),
                  _createElementVNode("p", null, [
                    _createTextVNode("the "),
                    _createElementVNode("span", { class: "highlight" }, "\"Green Comet\"")
                  ]),
                  _createElementVNode("p", null, "moves in our sky?")
                ], -1))
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  class: "splash-get-started",
                  onClick: _ctx.closeSplashScreen,
                  color: _ctx.accentColor,
                  density: _ctx.xSmallSize ? 'compact' : 'default',
                  size: "x-large",
                  variant: "elevated",
                  rounded: "lg"
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode(" Get Started ", -1)
                  ])),
                  _: 1,
                  __: [32]
                }, 8, ["onClick", "color", "density"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _cache[33] || (_cache[33] = _createTextVNode(" Brought to you by ", -1)),
                _cache[34] || (_cache[34] = _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Cosmic Data Stories", -1)),
                _cache[35] || (_cache[35] = _createTextVNode(" and ", -1)),
                _cache[36] || (_cache[36] = _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WorldWide Telescope", -1)),
                _cache[37] || (_cache[37] = _createTextVNode(". ", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
                ])
              ])
            ], 4)), [
              [_directive_click_outside, _ctx.closeSplashScreen]
            ])
          ]),
          _: 1
        }, 8, ["model-value", "style"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_5, _cache[38] || (_cache[38] = [
              _createElementVNode("div", { class: "container" }, [
                _createElementVNode("div", { class: "spinner" }),
                _createElementVNode("p", null, "Loading …")
              ], -1)
            ]), 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, {
              id: "video-icon",
              class: "control-icon",
              icon: "video",
              size: "lg"
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showLocationSelector,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showLocationSelector) = $event)),
              "fa-icon": "location-pin",
              id: "map-icon",
              color: _ctx.cometColor,
              "tooltip-text": "Select location",
              "tooltip-location": "bottom",
              "tooltip-offset": "5px"
            }, null, 8, ["modelValue", "color"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showTextSheet,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTextSheet) = $event)),
              id: "text-icon",
              color: _ctx.cometColor,
              "fa-icon": "book-open",
              "tooltip-text": "Learn more",
              "tooltip-location": "start",
              "tooltip-offset": _ctx.smallSize ? 0 : '10px'
            }, null, 8, ["modelValue", "color", "tooltip-offset"]),
            _createVNode(_component_icon_button, {
              modelValue: _ctx.showVideoSheet,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
              id: "video-icon",
              "fa-icon": "video",
              color: _ctx.cometColor,
              "tooltip-text": "Watch video",
              "tooltip-location": "start",
              "tooltip-offset": _ctx.smallSize ? 0 : '10px'
            }, null, 8, ["modelValue", "color", "tooltip-offset"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.imagesetFolder !== null)
            ? (_openBlock(), _createBlock(_component_folder_view, {
                key: 0,
                class: "folder-view",
                sliders: "",
                expandable: "",
                thumbnails: true,
                open: _ctx.mobile ? false : true,
                "root-folder": _ctx.imagesetFolder,
                "wwt-namespace": _ctx.wwtNamespace,
                incomingItemSelect: _ctx.incomingItemSelect,
                "flex-direction": "column",
                onSelect: _ctx.onItemSelected,
                onOpacity: _ctx.onOpacityChanged,
                onToggle: _ctx.onToggle
              }, null, 8, ["open", "root-folder", "wwt-namespace", "incomingItemSelect", "onSelect", "onOpacity", "onToggle"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_font_awesome_icon, {
                size: "lg",
                class: "ma-1",
                color: _ctx.cometColor,
                icon: _ctx.showControls ? `chevron-down` : `gear`,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showControls = !_ctx.showControls)),
                onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.showControls = !_ctx.showControls), ["enter"])),
                tabindex: "0"
              }, null, 8, ["color", "icon"])
            ]),
            _createVNode(_component_transition_expand, null, {
              default: _withCtx(() => [
                (_ctx.showControls)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.cometColor,
                        modelValue: _ctx.showAltAzGrid,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showAltAzGrid) = $event)),
                        onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.showAltAzGrid = !_ctx.showAltAzGrid), ["enter"])),
                        label: "Grid",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.cometColor,
                        modelValue: _ctx.showConstellations,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showConstellations) = $event)),
                        onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.showConstellations = !_ctx.showConstellations), ["enter"])),
                        label: "Constellations",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _createVNode(_component_v_checkbox, {
                        color: _ctx.cometColor,
                        modelValue: _ctx.showHorizon,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showHorizon) = $event)),
                        onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.showHorizon = !_ctx.showHorizon), ["enter"])),
                        label: "Horizon",
                        "hide-details": ""
                      }, null, 8, ["color", "modelValue"]),
                      _cache[40] || (_cache[40] = _createElementVNode("div", {
                        style: {"color":"white"},
                        class: "mt-3"
                      }, " Selected location's time: ", -1)),
                      _createVNode(_component_date_picker, {
                        dark: "",
                        "time-picker": "",
                        "enable-seconds": "",
                        "is-24": false,
                        modelValue: _ctx.timeOfDay,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.timeOfDay) = $event)),
                        clearable: false,
                        "close-on-scroll": "",
                        class: "mb-4 mt-1"
                      }, {
                        "input-icon": _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "clock",
                            class: "mx-2",
                            color: _ctx.cometColor
                          }, null, 8, ["color"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_btn, {
                        block: "",
                        color: _ctx.cometColor,
                        onClick: _ctx.centerOnCurrentDate,
                        onKeyup: _withKeys(_ctx.centerOnCurrentDate, ["enter"]),
                        class: "mb-2"
                      }, {
                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                          _createTextVNode(" Center on Now ", -1)
                        ])),
                        _: 1,
                        __: [39]
                      }, 8, ["color", "onClick", "onKeyup"]),
                      _createVNode(_component_v_btn, {
                        block: "",
                        color: _ctx.cometColor,
                        onClick: _cache[12] || (_cache[12] = () => {
                _ctx.playing = false;
                _ctx.playingCometPath = !_ctx.playingCometPath;
              })
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`${_ctx.playingCometPath ? 'Stop' : 'Play'} comet images`), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createVNode(_component_icon_button, {
                id: "play-pause-icon",
                "fa-icon": !(_ctx.playing || _ctx.playingCometPath) ? 'play' : 'pause',
                onActivate: _cache[13] || (_cache[13] = () => {
              _ctx.playing = !(_ctx.playing || _ctx.playingCometPath);
              _ctx.playingCometPath = false;
            }),
                color: _ctx.ephemerisColor,
                "tooltip-text": "Play/Pause",
                "tooltip-location": "top",
                "tooltip-offset": "5px"
              }, null, 8, ["fa-icon", "color"]),
              _createVNode(_component_vue_slider, {
                id: "slider",
                adsorb: "",
                included: "",
                marks: (d) => {
              return _ctx.allDates.includes(d) || _ctx.cometImageDates.includes(d);
            },
                order: false,
                modelValue: _ctx.selectedTime,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedTime) = $event)),
                onChange: _ctx.onTimeSliderChange,
                data: _ctx.dates,
                tooltip: "always",
                "tooltip-formatter": (v) => 
              _ctx.toDateString(new Date(v))
            
              }, {
                mark: _withCtx(({ pos, value }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'mark-line': _ctx.cometImageDates.includes(value) }]),
                    style: _normalizeStyle({ left: `${pos}%` })
                  }, null, 6)
                ]),
                _: 1
              }, 8, ["marks", "modelValue", "onChange", "data", "tooltip-formatter"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa-grantee'] })
            ])
          ])
        ]),
        _createVNode(_component_v_dialog, {
          class: "error-dialog",
          style: _normalizeStyle(_ctx.cssVars),
          modelValue: _ctx.showWebGL2Warning,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showWebGL2Warning) = $event)),
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => _cache[41] || (_cache[41] = [
                _createElementVNode("div", { class: "error-message" }, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, "This app requires WebGL 2")
                  ]),
                  _createElementVNode("p", { class: "mt-2" }, " Check your browser's settings and enable WebGL 2 (\"graphics acceleration\" on some browsers). "),
                  _createElementVNode("p", { class: "mt-2" }, [
                    _createTextVNode(" You can check whether your browser supports WebGL 2 and get assistance "),
                    _createElementVNode("a", {
                      href: "https://get.webgl.org/webgl2/",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "here"),
                    _createTextVNode(". ")
                  ])
                ], -1)
              ])),
              _: 1,
              __: [41]
            })
          ]),
          _: 1
        }, 8, ["style", "modelValue"]),
        _createVNode(_component_v_dialog, {
          id: "video-container",
          modelValue: _ctx.showVideoSheet,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showVideoSheet) = $event)),
          transition: "slide-y-transition",
          fullscreen: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_font_awesome_icon, {
                id: "video-close-icon",
                class: "close-icon",
                icon: "times",
                size: "lg",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showVideoSheet = false)),
                onKeyup: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.showVideoSheet = false), ["enter"])),
                tabindex: "0"
              }),
              _cache[42] || (_cache[42] = _createElementVNode("video", {
                controls: "",
                id: "info-video"
              }, [
                _createElementVNode("source", {
                  src: _imports_0,
                  type: "video/mp4"
                })
              ], -1))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          id: "location-dialog",
          modelValue: _ctx.showLocationSelector,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.showLocationSelector) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { id: "location-selector" }, {
              default: _withCtx(() => [
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "text-center" }, " Move around the map and double-click to change location ", -1)),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.getLocation,
                  onKeyup: _withKeys(_ctx.getLocation, ["enter"])
                }, {
                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                    _createTextVNode(" Use My Location ", -1)
                  ])),
                  _: 1,
                  __: [43]
                }, 8, ["onClick", "onKeyup"]),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.locationErrorMessage), 1),
                _cache[45] || (_cache[45] = _createElementVNode("div", { id: "map-container" }, null, -1))
              ]),
              _: 1,
              __: [44,45]
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          class: "bottom-sheet",
          id: "text-bottom-sheet",
          "hide-overlay": "",
          persistent: "",
          "no-click-animation": "",
          absolute: "",
          width: "100%",
          scrim: false,
          location: "bottom",
          modelValue: _ctx.showTextSheet,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.showTextSheet) = $event)),
          transition: "dialog-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { height: "100%" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.tab) = $event)),
                  height: "32px",
                  color: _ctx.cometColor,
                  "slider-color": _ctx.cometColor,
                  id: "tabs",
                  dense: "",
                  grow: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { tabindex: "0" }, {
                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                        _createElementVNode("h3", null, "Information", -1)
                      ])),
                      _: 1,
                      __: [46]
                    }),
                    _createVNode(_component_v_tab, { tabindex: "0" }, {
                      default: _withCtx(() => _cache[47] || (_cache[47] = [
                        _createElementVNode("h3", null, "Using WWT", -1)
                      ])),
                      _: 1,
                      __: [47]
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "color", "slider-color"]),
                _createVNode(_component_font_awesome_icon, {
                  id: "close-text-icon",
                  class: "control-icon",
                  icon: "times",
                  size: "lg",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showTextSheet = false)),
                  onKeyup: _cache[22] || (_cache[22] = _withKeys(($event: any) => (_ctx.showTextSheet = false), ["enter"])),
                  tabindex: "0"
                }),
                _createVNode(_component_v_window, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.tab) = $event)),
                  id: "tab-items",
                  class: "pb-2 no-bottom-border-radius"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "no-bottom-border-radius scrollable" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _cache[75] || (_cache[75] = _createTextVNode(" Comets are dusty snowballs, large clumps of rock and ice, that originate in the outer solar system. The “Green Comet” (or ", -1)),
                                _cache[76] || (_cache[76] = _createElementVNode("a", {
                                  href: "https://science.nasa.gov/comet-2022-e3-ztf",
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, "C/2022 E3", -1)),
                                _cache[77] || (_cache[77] = _createTextVNode(") makes its closest approach to the Sun (and to Earth) in early 2023. The comet images in this interactive view were taken on different dates from December 2022 through January 2023 by astrophotographer ", -1)),
                                _cache[78] || (_cache[78] = _createElementVNode("a", {
                                  href: "http://www.astrostudio.at/",
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, "Gerald Rhemann", -1)),
                                _cache[79] || (_cache[79] = _createTextVNode(". ", -1)),
                                _cache[80] || (_cache[80] = _createElementVNode("br", null, null, -1)),
                                _cache[81] || (_cache[81] = _createElementVNode("br", null, null, -1)),
                                _cache[82] || (_cache[82] = _createElementVNode("h3", null, "Explore!", -1)),
                                _cache[83] || (_cache[83] = _createTextVNode(" Adjusting the ", -1)),
                                _cache[84] || (_cache[84] = _createElementVNode("span", { class: "ui-element-ref-comet" }, "Date", -1)),
                                _cache[85] || (_cache[85] = _createTextVNode(" slider along the bottom of the screen shows you the position of the comet since it was discovered in March 2022. ", -1)),
                                _cache[86] || (_cache[86] = _createElementVNode("ul", { class: "text-list" }, [
                                  _createElementVNode("li", null, "Move the date slider forward and backward. Observe how the comet moves in the sky with time. Can you find when the comet is moving fastest in the sky and when it is moving slowest in the sky? Can you find when the comet path “twirls” in the sky? (This is known as “retrograde motion.”)"),
                                  _createElementVNode("li", null, "Click the thumbnail images on the left to see photographs of the comet in the virtual sky. Use the sliders under the thumbnails to display the comet images for multiple dates."),
                                  _createElementVNode("li", null, "Click \"Play comet images\" to view them in order by date. What do you notice about the direction of the comet’s tails relative to the motion of the comet?")
                                ], -1)),
                                _cache[87] || (_cache[87] = _createElementVNode("br", null, null, -1)),
                                _cache[88] || (_cache[88] = _createElementVNode("h3", null, "Why is the Comet Green?", -1)),
                                _cache[89] || (_cache[89] = _createTextVNode(" Visually, comets have three parts: the bright coma and two tails. The coma is material being vaporized off the comet’s surface by radiation from the Sun. The green color of the comet is due to dicarbon (a molecule made of two carbon atoms, C", -1)),
                                _cache[90] || (_cache[90] = _createElementVNode("sub", null, "2", -1)),
                                _cache[91] || (_cache[91] = _createTextVNode(") in the comet’s coma. When excited by ultraviolet light from the sun, dicarbon fluoresces with a blue-green light. ", -1)),
                                _cache[92] || (_cache[92] = _createElementVNode("br", null, null, -1)),
                                _cache[93] || (_cache[93] = _createElementVNode("br", null, null, -1)),
                                _cache[94] || (_cache[94] = _createElementVNode("h3", null, "A Comet’s Tail", -1)),
                                _cache[95] || (_cache[95] = _createTextVNode(" The comet has an ionized gas tail and a dust tail. The gas tail is composed of the gas being blown off the comet’s surface and ionized (given an electric charge) by ultraviolet radiation from the Sun. This charged gas is blown in a direction ", -1)),
                                _cache[96] || (_cache[96] = _createElementVNode("strong", null, "away", -1)),
                                _cache[97] || (_cache[97] = _createTextVNode(" from the Sun by the solar wind. The dust tail is made of dust blown off the surface by jets of vaporizing gas. The dust is electrically neutral and does not get pushed as hard by the solar wind, which is why it is generally distinct from the gas tail. Many people think that the tails trail behind the comet as it moves forward. You can see from the images that the solar wind is blowing the tails ahead of the comet for much of its path through space! ", -1)),
                                _cache[98] || (_cache[98] = _createElementVNode("br", null, null, -1)),
                                _cache[99] || (_cache[99] = _createElementVNode("br", null, null, -1)),
                                _cache[100] || (_cache[100] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", _hoisted_21, [
                                  _cache[48] || (_cache[48] = _createElementVNode("h3", null, "Credits:", -1)),
                                  _cache[49] || (_cache[49] = _createElementVNode("h4", null, [
                                    _createElementVNode("a", {
                                      href: "https://www.cosmicds.cfa.harvard.edu/",
                                      target: "_blank",
                                      rel: "noopener noreferrer"
                                    }, "CosmicDS"),
                                    _createTextVNode(" Team:")
                                  ], -1)),
                                  _cache[50] || (_cache[50] = _createTextVNode(" Jon Carifio", -1)),
                                  _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                                  _cache[52] || (_cache[52] = _createTextVNode(" John Lewis", -1)),
                                  _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1)),
                                  _cache[54] || (_cache[54] = _createTextVNode(" Pat Udomprasert", -1)),
                                  _cache[55] || (_cache[55] = _createElementVNode("br", null, null, -1)),
                                  _cache[56] || (_cache[56] = _createTextVNode(" Alyssa Goodman", -1)),
                                  _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
                                  _cache[58] || (_cache[58] = _createTextVNode(" Mary Dussault", -1)),
                                  _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1)),
                                  _cache[60] || (_cache[60] = _createTextVNode(" Harry Houghton", -1)),
                                  _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
                                  _cache[62] || (_cache[62] = _createTextVNode(" Anna Nolin", -1)),
                                  _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
                                  _cache[64] || (_cache[64] = _createTextVNode(" Evaluator: Sue Sunbury", -1)),
                                  _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
                                  _cache[66] || (_cache[66] = _createElementVNode("br", null, null, -1)),
                                  _cache[67] || (_cache[67] = _createElementVNode("h4", null, "WorldWide Telescope Team:", -1)),
                                  _cache[68] || (_cache[68] = _createTextVNode(" Peter Williams", -1)),
                                  _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
                                  _cache[70] || (_cache[70] = _createTextVNode(" A. David Weigel", -1)),
                                  _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
                                  _cache[72] || (_cache[72] = _createTextVNode(" Jon Carifio", -1)),
                                  _cache[73] || (_cache[73] = _createElementVNode("br", null, null, -1)),
                                  _cache[74] || (_cache[74] = _createElementVNode("br", null, null, -1)),
                                  _createVNode(_component_funding_acknowledgment)
                                ]),
                                _createVNode(_component_v_spacer, { class: "end-spacer" })
                              ]),
                              _: 1,
                              __: [75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100]
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "no-bottom-border-radius scrollable",
                          style: {"height":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "info-text no-bottom-border-radius" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_container, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => _cache[101] || (_cache[101] = [
                                                _createTextVNode(" Pan ", -1)
                                              ])),
                                              _: 1,
                                              __: [101]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "press + drag" : "click + drag"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? ":" : "W-A-S-D"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "keys"), 1),
                                            _cache[102] || (_cache[102] = _createElementVNode("br", null, null, -1))
                                          ]),
                                          _: 1,
                                          __: [102]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { align: "center" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              label: "",
                                              outlined: ""
                                            }, {
                                              default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                _createTextVNode(" Zoom ", -1)
                                              ])),
                                              _: 1,
                                              __: [103]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? "pinch in and out" : "scroll in and out"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "or") + " ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.touchscreen ? ":" : "I-O"), 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.touchscreen ? ":" : "keys"), 1),
                                            _cache[104] || (_cache[104] = _createElementVNode("br", null, null, -1))
                                          ]),
                                          _: 1,
                                          __: [104]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_22, [
                                              _cache[116] || (_cache[116] = _createElementVNode("h4", null, "Tips:", -1)),
                                              _createElementVNode("ul", _hoisted_23, [
                                                _createElementVNode("li", null, [
                                                  _cache[105] || (_cache[105] = _createTextVNode(" Click ", -1)),
                                                  _createVNode(_component_font_awesome_icon, {
                                                    class: "control-icon",
                                                    icon: "location-pin",
                                                    size: "lg"
                                                  }),
                                                  _cache[106] || (_cache[106] = _createTextVNode(" to adjust your location. ", -1))
                                                ]),
                                                _cache[109] || (_cache[109] = _createElementVNode("li", null, " Adjust the date slider at the bottom to see the location of the Green Comet on a particular day. ", -1)),
                                                _createElementVNode("li", null, [
                                                  _cache[107] || (_cache[107] = _createTextVNode(" Click ", -1)),
                                                  _createVNode(_component_font_awesome_icon, {
                                                    id: "play-pause-icon",
                                                    class: "control-icon",
                                                    icon: "play",
                                                    size: "lg"
                                                  }),
                                                  _cache[108] || (_cache[108] = _createTextVNode(" to auto-advance time. ", -1))
                                                ]),
                                                _cache[110] || (_cache[110] = _createElementVNode("li", null, " The small pink markers in the sky show the path of the comet on a particular date at 00:00 UT. The larger pink marker shows the position of the comet at the time displayed on the clock. Larger white'ish dots overlaid on the small pink dots indicate dates that have comet photographs. ", -1)),
                                                _cache[111] || (_cache[111] = _createElementVNode("li", null, " Click a thumbnail image in the panel in the upper left to see an image of the comet photographed by Gerald Rhemann overlaid on the virtual sky on that day. The slider under the thumbnail adjusts the image opacity within the sky view. ", -1)),
                                                _cache[112] || (_cache[112] = _createElementVNode("li", null, " Depending on what you are trying to see, you may want to try different zoom levels. Zooming out will help you see the comet's overall path better. Zooming in will help you see more details in the comet images. ", -1)),
                                                _cache[113] || (_cache[113] = _createElementVNode("li", null, " Choose whether to display the sky grid, constellations, or the horizon. ", -1)),
                                                _cache[114] || (_cache[114] = _createElementVNode("li", null, " Adjust the displayed time for your chosen location using the time controller. ", -1)),
                                                _cache[115] || (_cache[115] = _createElementVNode("li", null, " Re-center the view on the comet's location \"now\" or Play the comet images, in order, along their path. ", -1))
                                              ]),
                                              _cache[117] || (_cache[117] = _createElementVNode("br", null, null, -1)),
                                              _cache[118] || (_cache[118] = _createTextVNode(" This Data Story is powered by WorldWide Telescope (WWT). ", -1))
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _cache[119] || (_cache[119] = _createElementVNode("div", { class: "credits" }, [
                                              _createElementVNode("h3", null, "Credits:"),
                                              _createElementVNode("h4", null, [
                                                _createElementVNode("a", {
                                                  href: "https://www.cosmicds.cfa.harvard.edu/",
                                                  target: "_blank",
                                                  rel: "noopener noreferrer"
                                                }, "CosmicDS"),
                                                _createTextVNode(" Team:")
                                              ]),
                                              _createTextVNode(" Jon Carifio"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" John Lewis"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Pat Udomprasert"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Alyssa Goodman"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Mary Dussault"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Harry Houghton"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Anna Nolin"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Evaluator: Sue Sunbury"),
                                              _createElementVNode("br"),
                                              _createElementVNode("br"),
                                              _createElementVNode("h4", null, "WorldWide Telescope Team:"),
                                              _createTextVNode(" Peter Williams"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" A. David Weigel"),
                                              _createElementVNode("br"),
                                              _createTextVNode(" Jon Carifio"),
                                              _createElementVNode("br")
                                            ], -1)),
                                            _createVNode(_component_v_spacer, { class: "end-spacer" })
                                          ]),
                                          _: 1,
                                          __: [119]
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_expand_transition, null, {
              default: _withCtx(() => [
                (_ctx.showRating)
                  ? (_openBlock(), _createBlock(_component_user_experience, {
                      key: 0,
                      question: _ctx.question,
                      "icon-size": "3x",
                      onDismiss: _cache[27] || (_cache[27] = (_rating, _comments) => {
            _ctx.showRating = false;
          }),
                      onRating: _cache[28] || (_cache[28] = (rating) => {
            _ctx.currentRating = rating;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
          }),
                      onFinish: _cache[29] || (_cache[29] = (rating, comments) => {
            _ctx.currentRating = rating;
            _ctx.currentComments = comments;
            _ctx.updateUserExperienceInfo(_ctx.currentRating, _ctx.currentComments);
            _ctx.showRating = false;
          })
                    }, {
                      footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_v_btn, {
                            class: "rating-opt-put",
                            color: "#BDBDBD",
                            size: "small",
                            variant: "text",
                            onClick: _ctx.onOptOutClicked
                          }, {
                            default: _withCtx(() => _cache[120] || (_cache[120] = [
                              _createTextVNode(" Don't show again ", -1)
                            ])),
                            _: 1,
                            __: [120]
                          }, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            class: "privacy-button",
                            color: "#BDBDBD",
                            size: "small",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showPrivacyPolicy = true)),
                            onKeyup: _cache[26] || (_cache[26] = _withKeys(($event: any) => (_ctx.showPrivacyPolicy = true), ["enter"])),
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, {
                            default: _withCtx(() => _cache[121] || (_cache[121] = [
                              _createTextVNode(" What is this? ", -1)
                            ])),
                            _: 1,
                            __: [121]
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["question"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_cds_privacy_policy, {
              modelValue: _ctx.showPrivacyPolicy,
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.showPrivacyPolicy) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_notifications, {
          group: "startup-location",
          position: "top right"
        })
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}